module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASBAMAAACtCzMeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTKurq6ysrKysrK+vr6ysrK2tra+vr6+vr62tra2tra2trZPZkpUAAAALdFJOUwBAX9cQ8J8wIH/AdC58IwAAAHBJREFUCNdj0N4NA5sYdjDAQCsS25thE5ytzbDZAcpkiWbYagJlO0czbEguADM5zLgZNnCGg9mlE4BsBlUFIJPJiAHEZg8DsqcWgNkMzikMXkATwGyWZCUzByibgWkVSAuEDQG42UGCMKDKIAz3izkA1H8j4/0wb7kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mailIcon.png
// module id = 1767
// module chunks = 5